import React from "react";
import { FaArrowRight } from "react-icons/fa6";

// Left-aligned section heading used on the website-development page:
// optional pill, title (+ gradient part), subtitle, and an optional CTA button on the right.
export const Pill = ({ children }) => (
  <span className="inline-flex items-center rounded-full bg-[#E9F0FF] px-[18px] py-[6px] text-[12px] font-medium uppercase tracking-[0.12em] text-[#1E6BFF]">
    {children}
  </span>
);

export const CtaButton = ({ href, children }) => (
  <a
    href={href}
    className="group inline-flex h-[50px] shrink-0 items-center gap-[10px] rounded-full bg-gradient-to-r from-[#0EA5FF] via-[#3D5BF6] to-[#A21CF0] px-[26px] text-[15px] font-medium text-white shadow-[0_14px_30px_-14px_rgba(91,61,245,0.7)] transition hover:brightness-110"
  >
    {children}
    <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
  </a>
);

const WebSectionHead = ({ pill, title, highlight, br = false, subtitle, cta }) => (
  <div className="flex flex-col gap-[20px] md:flex-row md:items-end md:justify-between">
    <div className="max-w-[920px]">
      {pill && <Pill>{pill}</Pill>}
      <h2 className={`${pill ? "mt-[14px]" : ""} text-[30px] font-bold leading-[1] tracking-tight text-ink sm:text-[38px] xl:text-[44px]`}>
        {title}
        {highlight && (
          <>
            {br ? <br /> : " "}
            <span className="text-gradient">{highlight}</span>
          </>
        )}
      </h2>
      {subtitle && <p className="mt-[12px] max-w-[620px] text-[15px] leading-[1.6] text-slate-600 sm:text-[16px]">{subtitle}</p>}
    </div>
    {cta && <div className="md:mb-[40px]">{cta}</div>}
  </div>
);

export default WebSectionHead;
